<template>
    <div class="p-register-card">
        <div class="register-card">
            <h1 class="title" v-html="boxTitle" />
            <h2 class="sub-title" v-html="boxSlogan" />
            <form autocomplete="off" @submit.prevent="submit">
                <div class="form-con">
                    <div class="form-group" v-if="showDesktop">
                        <label class="desktop-only">{{ 'I am a' | translate }}</label>
                        <select-wrapper>
                            <select class="form-control rounded-right" v-model="preference">
                                <option v-for="(val, key) in preferences" :key="key" :value="val.value">{{ val.label }}</option>
                            </select>
                        </select-wrapper>
                    </div>
                    <div class="form-group" v-if="showDesktop">
                        <label class="desktop-only">{{ 'Location' | translate }}</label>
                        <div class="province-country-select-wrapper">
                            <select-wrapper v-if="countries.length >= 2">
                                <select class="form-control rounded-right" ref="select-country" v-model="country" @change="loadProvinces()">
                                    <option :disabled="val.id!==country && (val.disabled || false)" v-for="(val, key) in countries" :key="key" :value="val.id">{{ val.name }}</option>
                                </select>
                            </select-wrapper>
                            <select-wrapper>
                                <select class="form-control rounded-right" ref="select-province" v-model="province">
                                    <option v-for="(val, key) in provinces" :key="key" :value="val.id">{{ val.name }}</option>
                                </select>
                            </select-wrapper>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="tbn-wrapper">
                            <button v-if="showDesktop" class="btn btn-orange" :disabled="loading">
                                <span v-html="boxButton" />
                            </button>
                            <button v-else class="btn btn-orange" :disabled="loading" @click.prevent="submitClickedMobile">
                                <span v-html="boxButton" />
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <slot ref="slot"></slot>
    </div>
</template>

<script>
    import SelectWrapper from '@theme-views/common/SelectWrapper'
    import PRegisterCard from '@views/public/partials/PRegisterCard/p_register_card'

    export default {
        mixins: [PRegisterCard],
        components: {SelectWrapper}
    }
</script>

<style lang="scss">
.p-register-card {
    .form-con {
        margin-top: 22px;
        .select-wrapper {
            width: 250px;
            select {
                font-family: 'Nunito';
                font-size: 14px;
                @include font-settings(normal, normal, normal, 1.36, normal);
                color: #222222;
            }
        }

        .form-group {
            margin-bottom: 25px;
            label {
                display: inline-block;
                margin-bottom: 0.5rem;
                font-family: 'Quicksand';
                font-size: 16px;
                @include font-settings(normal, normal, normal, 1.31, bold);
                color: #222222;
            }
        }
    }
    .btn-orange {
        margin: 0;
        min-width: 250px;
        max-width: 100%;
        min-height: 50px;
    }

    .province-country-select-wrapper {
        display: flex;
        flex-direction: row;
        width: 100%;
        .select-wrapper:first-child:not(:last-child) {
            width: 80px;
            margin-right: 10px;
        }
        .select-wrapper:last-child:not(:first-child) {
            width: 160px;
        }
        @media(max-width: 1199px) {
            width: 100%;
            max-width: initial;
        }
    }
}
</style>
